import { Button, ButtonGroup } from "@/components/ui/Button";
import { useSearch } from "@/contexts/SearchContext";
import { PropertyListingViewType } from "@/enums/property.enum";
import { ListIcon, MapPinIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

export const SwitchPropertyView = () => {
  const t = useTranslations("shared");
  const { view, updateView, updateCoordinates } = useSearch();

  const handleChange = useCallback((value: PropertyListingViewType) => {
    if (value === PropertyListingViewType.LIST) {
      updateCoordinates(null);
    }
    updateView(value);
  }, []);

  return (
    <ButtonGroup>
      <Button
        variant={view === PropertyListingViewType.LIST ? "secondary" : "ghost"}
        onClick={() => handleChange(PropertyListingViewType.LIST)}
      >
        <ListIcon className="size-5" />
        {t("words.list")}
      </Button>
      <Button
        variant={view === PropertyListingViewType.MAP ? "secondary" : "ghost"}
        onClick={() => handleChange(PropertyListingViewType.MAP)}
      >
        <MapPinIcon className="size-5" />
        {t("words.map")}
      </Button>
    </ButtonGroup>
  );
};
